import React, { useState, useEffect } from 'react';
// Import components
import HeroSection from './HeroSection';
import MetricsSection from './Metrics';
import FeaturesSection from './Features';
import ServiceMetrics from './ServiceMetrics';
import SuccessStories from './SuccessStories';
import CTASection from './CTASection';
import Footer from './Footer';

const LandingPage = ({ onNavigate = () => { } }) => {
    const [scrollPosition, setScrollPosition] = useState(0);

    useEffect(() => {
        const handleScroll = () => setScrollPosition(window.scrollY);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const parallaxOffset = scrollPosition * 0.5;

    return (
        <div className="min-h-screen bg-slate-900 text-white">
            <HeroSection parallaxOffset={parallaxOffset} />
            <MetricsSection />
            <FeaturesSection />
            <ServiceMetrics />
            <SuccessStories />
            <CTASection onNavigate={onNavigate} />
            <Footer />
        </div>
    );
};

export default LandingPage;